import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import { useEffectOnce } from 'react-use'
import styled from 'styled-components'

import { reatomLocalPasswordEditFlow } from '../atoms/update-local-password'
import { reatomPasswordEditFlow } from '../atoms/update-password'

import { UpdatePasswordCurrent } from './update-password-current'
import { UpdatePasswordUpdate } from './update-password-update'

type Props = {
  type: 'password' | 'local-password'
  onPasswordUpdated: () => void
}

export const UpdatePassword: React.FC<Props> = ({
  onPasswordUpdated,
  type,
}) => {
  const model = useMemo(
    () =>
      type === 'password'
        ? // eslint-disable-next-line @reatom/unit-naming-rule
          reatomPasswordEditFlow()
        : // eslint-disable-next-line @reatom/unit-naming-rule
          reatomLocalPasswordEditFlow(),
    [type],
  )
  const [stage] = useAtom(model.stageAtom)

  useEffectOnce(() => {
    // navigate to the previous screen
    model.passwordUpdatedEvent.onCall(onPasswordUpdated)
  })

  const Screen =
    stage.type === 'current-password'
      ? UpdatePasswordCurrent
      : UpdatePasswordUpdate

  return (
    <Root>
      <Screen model={model} />
    </Root>
  )
}

const Root = styled.div`
  gap: 10px;
  min-height: 400px;

  display: grid;
  align-content: center;
`
